import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';

import { AppRoute } from '@/common/app/routes';
import { useCheckVIPstatus } from '@/common/hooks/checkVIPstatus';
import { ModalContext } from '@/components/Modals/Modal/config';
import { H3 } from '@/components/Typography/Typography';
import { BlueButton, SecondaryButton } from '@/components/ui/Button/Button';

import { EarnInfo } from './EarnInfo/EarnInfo';
import { EarnTonButton } from './EarnTonButton/EarnTonButton';
import VipEarnInfo from './VipEarnInfo/VipEarnInfo';

import css from './styles.module.scss';

const EarnTonSection: FC = () => {
  const { t } = useTranslation();
  const { openModal } = useContext(ModalContext);
  const navigate = useNavigate();
  const statusVIP = useCheckVIPstatus();

  return (
    <div className="w-full px-2 mb-4">
      <div
        className={cn('w-full rounded-lg p-3 flex flex-col gap-4', css.earnTon)}
      >
        <EarnTonButton />
        <EarnInfo />
        {statusVIP && <VipEarnInfo />}
        <div className="flex w-full gap-2">
          <SecondaryButton
            onClick={() => {
              openModal({ renderKind: 'revenueDetails', props: undefined });
            }}
            text={t('Details')}
            className="flex-1 !w-auto"
          />
          <BlueButton
            onClick={() => navigate(AppRoute.SETTINGS)}
            className="flex-1 !w-auto"
          >
            <H3
              weight="extrabold"
              className={cn(css.blueButtonText, '!text-white/80')}
            >
              {t('Wallet')}
            </H3>
          </BlueButton>
        </div>
      </div>
    </div>
  );
};

export { EarnTonSection };
